import { render, staticRenderFns } from "./PriceModule.vue?vue&type=template&id=3c4bf01a&scoped=true"
import script from "./PriceModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./PriceModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PriceModule.vue?vue&type=style&index=0&id=3c4bf01a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4bf01a",
  null
  
)

export default component.exports